import { render, staticRenderFns } from "./Whatsapp.vue?vue&type=template&id=1234caf2&scoped=true"
import script from "./Whatsapp.vue?vue&type=script&lang=ts"
export * from "./Whatsapp.vue?vue&type=script&lang=ts"
import style0 from "./Whatsapp.vue?vue&type=style&index=0&id=1234caf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1234caf2",
  null
  
)

export default component.exports